import { post, postExFile, postFile } from "@utils/httpUtil";
import axios from "axios";
// 运营策略设置-生日关怀配置
export function configSettingBirthdayCareGet(data, config) {
  return post(`/c/pc/community/doctor/configSetting/birthdayCare/get`, data, config);
}
// 运营策略设置 - 编辑生日关怀;
export function configSettingBirthdayCareEdit(data, config) {
  return post(`/c/pc/community/doctor/configSetting/birthdayCare/edit`, data, config);
}
// 用户列表 - 分页查询
export function communityUserGetPageInfo(data, config) {
  return post(`/c/pc/community/user/getPageInfo`, data, config);
}
// 用户列表 - 更新备注
export function communityUserUpdateRemarks(data, config) {
  return post(`/c/pc/community/user/update`, data, config);
}
// 医生列表 - 保存消息推送;
export function saveUserMessageCustom(data, config) {
  return post(`/c/pccommunity/message/v2/saveUserMessageCustom`, data, config);
}
// 医生列表 - 编辑消息推送;
export function updateUserMessageCustom(data, config) {
  return post(`/c/pccommunity/message/v2/updateUserMessageCustom`, data, config);
}
export function messageFindUserPageMessage(data, config) {
  return post(`/c/pccommunity/message/v2/findUserPageMessage`, data, config);
}
// 医生列表 - 查询消息详情 - 列表;
export function findUserMessageDetailList(data, config) {
  return post(`/c/pccommunity/message/v2/findUserMessageDetailList`, data, config);
}
// 医生列表 - 查询消息详情 - 列表;
export function exportUserMessageDetailList(data, config) {
  return postExFile(`/c/pccommunity/message/v2/exportUserMessageDetailList`, data, config);
}
// 上下架, 导出数据
export function userExportData(data, config) {
  return postExFile(`/c/pc/community/user/exportData`, data, config);
}
// 添加saas用户
export function addSaasCommunityUser(data, config) {
  return post(`/c/pc/community/user/addSaasCommunityUser`, data, config);
}
// 添加saas用户校验检查
export function addSaasCommunityUserCheck(data, config) {
  return post(`/c/pc/community/user/addSaasCommunityUserCheck`, data, config);
}
// saas用户导入
export function saasCommunityUserImport(data, config) {
  return postFile(`/c/pc/community/user/userImport`, data, config);
}
// 获取当前用户家庭成员列表
export function getFamilyMembers(data, config) {
  return post(`/c/pc/community/user/getFamilyMembers`, data, config);
}
// 获取当前用户家庭成员列表
export function findPermissionModules(data, config) {
  const instance = axios.create({
    baseURL: ""
  });
  return instance.post(`/pch5/patient/family/findPermissionModules`, data, config);
}
// 获取当前用户家庭成员列表
export function addPermission(data, config) {
  const instance = axios.create({
    baseURL: ""
  });
  return instance.post(`/pch5/patient/family/addPermission`, data, config);
}